/**
 * Created by michael.chi on 04/29/22.
 */
import React from 'react';
import '../../css/login.css';
import env from '../../env';

class Banner extends React.Component {

    render() {
        const fedRampWarnBanner = "WARNING - PRIVATE ELECTRONIC DEVICE - UNAUTHORIZED ACCESS PROHIBITED: "
        const fedRampWarnDetail = "This device is a private network device. Any attempt for unauthorized access will be logged and appropriate legal action will be taken. Unauthorized use may subject you to criminal prosecution. Evidence of any such unauthorized use collected during monitoring may be used for administrative, criminal, or other adverse action. Use of this system constitutes consent to monitoring for these purposes."

        if (env.FEDRAMP === 'true') {
            return (
                <div className="banner">
                    <b>{fedRampWarnBanner}</b><br />{fedRampWarnDetail}
                </div>
            );
        } else {
            return (null);
        }
    }
}

export default Banner;
